<template>
  <div>
    <VideoFeedback v-if="showVideo" @close="showVideo = false" :url='roomQuestions[thisQuestion].answers[thisAnswer].feedback'></VideoFeedback>
    <div class="m-background__overlay-blue"></div>
    <div id="reset-wrapper"><a @click="showConfirm = true" class="brand-logo"><img src="../assets/images/icons/home.png" class="full-logo"></a></div>
    <ConfirmReset v-if="showConfirm" @close="showConfirm = false"></ConfirmReset>
    <div class="l-container l-pad">
      <h3>Tips and Advice</h3>
      <p>{{roomQuestions[thisQuestion].tip}}</p>
      <a @click="checkEnd(room.name)" class="forward"><span class="m-btn__arrow m-btn__feedback"></span></a>
    </div>
    <MainFooter />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Brand from '../components/Brand'
import VideoFeedback from '../components/VideoFeedback'
import MainFooter from '../components/MainFooter'
import ConfirmReset from '../components/ConfirmReset'

export default {
  data () {
    return {
      thisRoom: this.$route.params.room,
      thisQuestion: this.$route.params.question - 1,
      thisAnswer: this.$route.params.answer - 1,
      showVideo: true,
      showConfirm: false
    }
  },
  computed: {
    ...mapGetters(['getRoom', 'getRoomQuestions', 'getQuestions', 'getScore']),
    room () {
      const roomID = parseInt(this.thisRoom, 10)
      return this.getRoom(roomID)
    },
    roomQuestions () {
      const roomID = parseInt(this.thisRoom, 10)
      return this.getRoomQuestions(roomID)
    },
    questionsAnswered () {
      return this.getQuestions.filter(q => q.answered).length
    }
  },
  methods: {
    checkEnd (routeRoom) {
      if (this.questionsAnswered < 8) {
        this.$router.push({ name: routeRoom })
      } else {
        this.$router.push({ name: 'survey' }) // editied to get to survey results...
        // this.$router.push({ name: 'result' })
      }
    }
  },
  components: {
    Brand,
    VideoFeedback,
    MainFooter,
    ConfirmReset
  },
  name: 'Feedback'
}
</script>

<style scoped lang='scss'>

h3 {
  color: #fff;
  @media (max-width: 899px) {
    font-size:2rem;
    margin-bottom:10px;
  }
}
p {
  width: 100%;
  white-space: pre-line;
  color: #fff;
  font-size: 1.4rem;
  @media (max-width: 899px) {
    font-size:0.9rem;
    width:95%;
    margin:0 0 0 0;
  }
}
a.forward {
  cursor: pointer;
  position: absolute;
  right: 12px;
  bottom: 14px;
}
.m-btn__feedback {
  width: 20px;
  height: 26px;
  display:inline-block;
  background-image:url(data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAwCAYAAAB9sggoAAABpElEQVRYhc2Zvy5EQRSHPxsSlUqnVBEqjUTJC3iBVaFApeEF1gPwAjwAHsDWaDQkqi11Oo1CcmWSIZN7dif37pw7c75md3Nusie/+fPNzs5UVfUAHAIjDNEDtoE34AyYs9KaS6wKPr8C+8CzeDIzvdrXrQOPwCWwULKxemIhH8AxcC8qGagnFrIE3AG3/r2Zxv7YBd6Bo4bPqxAbynE8AQd+kXRK2wQ2gRdgAMyLasHEQkZ+Yx6KigIpc2YZcNa4BhZFNRGNydz3i6MvKgmkDOU4hlre1V7+at7VTiwkybtdbphJ3u0ysZDW3s2lmNbezeY+T2Pv5hrKcUS9G+26Y6LeLZlYiPBuycRChHetJBbyCZxaSUxgrbEbYMW9zopSGcxN/h/gAlirn4RLJmZug/3yQt+a1BQFEnMiP/GnjSi5GjN37HGb9xWw2vYOpMvEzB2tv4FzYCPlnk07MXM/35x494Adrbtcjcb+/SYqCaQMpfCbJtMkNtFvmrRNLOq3Eok18psmTRJr7LdcjZm7Tp/ab5rUEzP3l42K3zRxian5TQ3gF3JhhejnVvqvAAAAAElFTkSuQmCC);
  background-size:cover;
  margin-top: -0.4em;
  color:#fff;
  @media (max-width: 899px) {
      width: 20px;
      height: 27px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Feedback.vue